import React from 'react';

import { Heading } from '@eluve/components';

export interface ArtifactHeaderProps {
  text: string;
}

export const ArtifactHeader: React.FC<ArtifactHeaderProps> = ({ text }) => {
  return (
    <Heading size="xl" weight="semibold" level={2}>
      {text}
    </Heading>
  );
};
